import { Redirect } from "react-router-dom";
import { SettingR } from "../route";
import { SettingsTemplate } from "../../../template/settings/default-template";
import { StaticFeatureFlags } from "../../../../feature-flags";
import { WarningBanner } from "@graffer-inc/console-design-kit";
import { useAuthContextV2 } from "../../../../auth-state";
import { PaymentRawdata } from "./payment-rawdata";
import { Payment3DSecureAuthRawdata } from "./3dsecure-auth";
import { availableTDS } from "@graffer-inc/cloud-gov-core";
import { usePaymentsRawdataPageHooks } from "./hooks";

export const PaymentsRawdataPage = () => {
  const { auth } = useAuthContextV2();

  const { orgPaymentSetting } = usePaymentsRawdataPageHooks({
    orgId: auth.orgId,
  });

  if (!auth.hasPermissions("payments_rawdata.read")) {
    return <Redirect to={SettingR.MyAccount.link({})} />;
  }

  return (
    <SettingsTemplate breadcrumbs={[{ to: "#", title: "決済データ" }]}>
      <h1 className="title">
        <i className="fa fa-file-alt" /> 決済データ
      </h1>
      {StaticFeatureFlags.IS_SANDBOX ? (
        <WarningBanner message="サンドボックス環境では、決済データをダウンロード頂くことはできません。" />
      ) : (
        <div>
          <h2 className="subtitle">決済データ</h2>
          <PaymentRawdata />
          {availableTDS(orgPaymentSetting, true) && (
            <div className="mt-5">
              <h2 className="subtitle">3-Dセキュア認証データ</h2>
              <Payment3DSecureAuthRawdata />
            </div>
          )}
        </div>
      )}
    </SettingsTemplate>
  );
};
